import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/user-settings')({
  staticData: {
    title: 'pages.userSettings.title',
    description: 'pages.userSettings.description',
  },
  component: UserSettingsPage,
});

function UserSettingsPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">User Settings</h1>
        <p className="mt-2 text-gray-600">
          Manage your account and preferences
        </p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          User Settings Page
        </h2>
        <p className="text-gray-600">
          This page will allow users to manage their account settings and
          preferences.
        </p>
      </div>
    </div>
  );
}
